import Cookies from 'universal-cookie';

/**
 * @function setItem stores data in Storage with expire date
 * @param key stored data key
 * @param value value to store
 * @param expire expire data can be undefined to not set expire data
 */
export const setItem = (key, value, expire) => {
  try {
    if (expire) {
      const now = Date.now();
      const expiresIn = now + expire * 1000;
      localStorage.setItem(`${key}_expiresIn`, expiresIn.toString());
    }
    localStorage.setItem(key, value);
  } catch (error) {
    console.log("error in set item",error)
  }
  
};

/**
 * @function getItem checks if data has expire data if true and has passed that time will remove all data otherwise return data
 * @param key sotred data key
 */
export const getItem = (key) => {
  try {
    const expiresIn = localStorage.getItem(`${key}_expiresIn`);
  if (expiresIn) {
    const now = Date.now();

    if (Number(expiresIn) > now) {
      // expired
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}_expiresIn`);

      return;
    } else {
      return localStorage.getItem(key);
    }
  } else {
    return localStorage.getItem(key);
  }
  } catch (error) {
    console.log("error in trycatch get item", error)
  }
  
};

export const setOTPTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('otptoken', value, { path: '/', maxAge: 1000 * 60 * 3, sameSite: true });
};
export const getOTPTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('otptoken')
}

export const removeOTPTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('otptoken', { path: '/' })
};

export const setRefreshTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('refreshtoken', value, { path: '/', maxAge: 1000 * 60 * 60 * 24 * 7, sameSite: true }); // 7 days
};
export const getRefreshTokenCookie= () =>{
  try {
    const cookies = new Cookies();
  return cookies.get('refreshtoken')
  } catch (error) {
    console.log("error in get refresh", error)
  }
  
}
export const removeRefreshTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('refreshtoken', { path: '/' })
};

export const setAccessTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('accesstoken', value, { path: '/', maxAge: 3 * 60 * 60, sameSite: true }); //1 hour
};
export const getAccessTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('accesstoken')
}
export const removeAccessTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('accesstoken', { path: '/' })
};
